import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { IconMapPin, IconMessageCircle, IconPackage } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

const emptyStates = {
  'place.noListingsOffer': { Icon: IconPackage, subtitle: 'empty.offers' },
  'place.noListingsRequest': { Icon: IconMessageCircle, subtitle: 'empty.requests' },
  'place.noFrequentedPlaces': { Icon: IconMapPin, subtitle: 'empty.places' },
  'place.noListingsOnSite': { Icon: IconPackage, subtitle: 'empty.onSite' },
} as const;

export function ProfileListingEmpty({ translationKey }: { translationKey: keyof typeof emptyStates }) {
  const { t } = useTranslation('neighbour-profile');
  const { Icon, subtitle } = emptyStates[translationKey];
  return (
    <Column
      alignItems="center"
      paddingHorizontal="spacing.general.x4"
      paddingTop="spacing.general.x5"
      paddingBottom="spacing.general.x6"
    >
      <Column
        alignItems="center"
        justifyContent="center"
        width={64}
        height={64}
        borderRadius="radius.full"
        backgroundColor="surface.primary-neutral"
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
      >
        <Icon size={32} strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['text.emphasized']} />
      </Column>
      <Text
        variant="bodyBase"
        fontWeight="700"
        textAlign="center"
        marginTop="spacing.general.x4"
        style={{ maxWidth: 320 }}
      >
        {t(translationKey)}
      </Text>
      <Text
        variant="bodyBase"
        color="text.secondary"
        textAlign="center"
        marginTop="spacing.general.x1"
        style={{ maxWidth: 320 }}
      >
        {t(subtitle)}
      </Text>
    </Column>
  );
}
